import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, take} from 'rxjs';
import {environment} from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class StatisticsApiService {
    private http = inject(HttpClient);
    private readonly apiServiceUrl = environment.serviceApi;

    getDashboardStatistics(): Observable<any> {
        return this.http.get(`${this.apiServiceUrl}/v1/statistics`).pipe(take(1));
    }

}

